<template>
  <div class="qy_explain">
    <div class="qrcode">
      <div class="img">
        <img class="img__inner" src="@/assets/img/gzh_qrcode.jpg" alt="">
      </div>
      <p class="label">长安二维码关注“柏慧康医检”公众号</p>
    </div>
    <div class="explain">
      <div class="item">
        <div class="tag">
          <div class="tag__inner"></div>
        </div>
        <div class="content">尊敬的用户，感谢您一直以来对“检测院外宝”微信公众号的支持与陪伴。</div>
      </div>
      <div class="item">
        <div class="tag"><div class="tag__inner"></div></div>
        <div class="content">由于账号主体变更，本公众号将进行迁移。为提供更高效、更优质的院外检测服务，请长按上方二维码关注我们的新公众号“柏慧康医检”。我们将继续为您提供院外检测和报告查看服务。</div>
      </div>
      <div class="item">
        <div class="tag"><div class="tag__inner"></div></div>
        <div class="content">对此带来的不便，我们深表歉意，感谢您的谅解与支持！</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
  .qy_explain {
    width: 100%;
    min-height: 100vh;
    background-color: #F5f6f7;
    box-sizing: border-box;
    padding: 40px 50px;
  }

  .qy_explain .qrcode .img__inner {
    width: 100%;
    vertical-align: middle;
  }
  .qy_explain .qrcode  {
    border-radius: 16px;
    padding: 40px 40px 60px;
    background-color: #FFF;
    text-align: center;

    font-family: PingFang SC;
    font-size: 32px;
    font-weight: normal;
    line-height: 48px;
    color: #8F959E;
  }

  .qy_explain .explain {
    margin-top: 40px;
  }
  .qy_explain .explain .item {
    display: flex;
    align-items: flex-start;

    font-family: PingFang SC;
    font-size: 28px;
    font-weight: normal;
    line-height: 50px;
    color: #646A73;
  }
  .qy_explain .explain .item .tag {
    flex: 0 0 30px;
  }
  .qy_explain .explain .item .tag .tag__inner {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-top: 20px;
    background-color: @primary;
  }
  .qy_explain .explain .item .content {
    flex: auto;
    width: calc(100% - 30px);
    box-sizing: border-box;
  }
</style>